interface ITextAreaField {
  placeholder?: string;
  value: string;
  disabled?: boolean;
  onChange: (data: string) => void;
  error?: string;
  onBlur?: () => void;
  row?: number;
}

const Textarea: React.FC<ITextAreaField> = ({
  placeholder = '',
  value = '',
  disabled = false,
  onChange = (data: string) => {},
  error = '',
  onBlur = () => {},
  row = 3,
}) => {
  return (
    <div className="flex flex-wrap items-center w-full">
      <textarea
        className={`flex items-center px-3 py-3 border-1.5 rounded-1 
        ${error ? 'border-red-500' : 'border-grey'} focus:border-active outline-none text-base 
        text-black2
        placeholder:text-grey2 placeholder:text-sm disabled:bg-grey1 w-full`}
        placeholder={placeholder}
        disabled={disabled}
        rows={row}
        value={value}
        onBlur={onBlur}
        onChangeCapture={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
      />
      {error && <p className=" font-regular text-xs text-red-500">{error}</p>}
    </div>
  );
};

export default Textarea;
